import { Status } from './Status';
import useFallback from './useFallback';

interface FallbackProps {
  error?: Error;
}

export const Fallback = ({ error }: FallbackProps) => {
  const statusProps = useFallback(error);

  // any other error
  return <Status {...statusProps} />;
};
